'use client';

import { twMerge } from 'utilities/src/twMerge';
import React from 'react';

type CardContainerProps = {
  children: any;
  classes?: string;
};

function CardContainer({ children, classes = '' }: CardContainerProps) {
  return <div className={twMerge('flex flex-col items-start py-6', classes)}>{children}</div>;
}

export default CardContainer;
